export default __webpack_public_path__ + "static/ciel_intro-1b6ea8fff08e97f68db17c818a2ff544.webm";